
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ScheduleHApi } from '../api/schedule-h.api';
import { switchMap, map } from 'rxjs/operators';
import { ScheduleHData, ScheduleH } from '../../../interfaces/masters/schedule-h';

@Injectable()
export class ScheduleHService extends ScheduleHData {

  constructor(private api: ScheduleHApi) {
    super();
  }



  list(url: string): Observable<ScheduleH[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<ScheduleH>{
      return this.api.getById(url);
  }

 
  searchList(url: string,data:any): Observable<any> {
     
    return this.api.searchList(url,data);
  }

  update(url: string, data:ScheduleH): Observable<ScheduleH> {
    return this.api.update(url,data);
  }
 

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  searchForMultiBranch(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }
}
